import React from "react";
import {
  Edit,
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  ReferenceInput,
  SelectInput,
  required,
  BooleanInput,
} from "react-admin";
import VideoUpload from "../upload/FileUploader";
import { FormToolbar } from "../../common/FormToolbar";

export const PolicyTypeCreate = (props) => {
  let defaultValues = {
    
    isActive: true,
    code:"-",
    isNonTarrif:false, 
    isRenewalMail:false,
    isNonPos:false, 
    isTpa:false
    
    
    
    
  };
  return (
    <Create title="Policy Type  Create" {...props} undoable={false} >
      <SimpleForm redirect="list" toolbar={<FormToolbar {...props} showDelete={false} />} variant="outlined"   initialValues={defaultValues}>
      
       <TextInput source="name"  fullWidth={true}  validate={[required()]}/>
       <ReferenceInput label="Policy Category " fullWidth={true} source="policyCategoryId" reference="policy-categories" >
            <SelectInput optionText="name"  />
        </ReferenceInput>

       <ReferenceInput label="Policy Department " fullWidth={true} source="policyDepartmentId" reference="life-policy-departments" >
            <SelectInput optionText="name"  />
        </ReferenceInput>

        
        <BooleanInput source="isNonTarrif" validate={[required()]}  label="Is Non Tarrif" />
        <BooleanInput source="isNonPos" validate={[required()]}  label="Is Non Pos" />
        <BooleanInput source="isTpa" validate={[required()]}  label="Is TPA" />
        <BooleanInput source="isRenewalMail" validate={[required()]}  label="is Renewal Mail" />
        <BooleanInput source="isActive" validate={[required()]}  label="Active" initialValue={true}/>
      </SimpleForm>
    </Create>
  );
};
